import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

// local imports
import { IOnCampusCoiffeurServiceFirmStatistics } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function CoiffeurServiceDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('dashboard.on-campus-tabs.female-res'),
          t('dashboard.on-campus-tabs.male-res'),
          t('dashboard.num-of-all-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const { FirmName, FemaleCount, MaleCount, TotalCount } = res
        return { FirmName, FemaleCount, MaleCount, TotalCount }
      })

      const totalRow = arr.reduce(
        (acc: IOnCampusCoiffeurServiceFirmStatistics, curr: IOnCampusCoiffeurServiceFirmStatistics) => {
          acc.femaleCount += curr.femaleCount || 0
          acc.maleCount += curr.maleCount || 0
          acc.totalCount += curr.totalCount || 0
          return acc
        },
        {
          FirmName: '',
          FemaleCount: 0,
          MaleCount: 0,
          TotalCount: 0,
        }
      )

      let heading2 = {
        FirmName: '',
        FemaleCount: t('most-used-words.female'),
        MaleCount: t('most-used-words.male'),
        TotalCount: t('dashboard.on-campus-tabs.all-coiffeur-detail-msg'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.on-campus-tabs.coiffeur-res'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
